import React, { Component } from 'react';
import Modal from './Modal';
import ButtonLink from '../Button/ButtonLink';
import { setWhatYouNeedToKnow } from '../../../analytics/gatherService';

type Props = {
  btnContent: string,
  btnAlignTop: boolean,
  groupIndex: number,
  fulfillmentType: string,
  modalHeading: string,
  height: string,
  width: string,
  children: any,
  dataId?: string,
};

class InfoModal extends Component<Props> {
  constructor() {
    super();
    this.state = {
      isModalOpen: false,
    };
  }

  onClickOpenModal = () => {
    const { fulfillmentType } = this.props;
    this.setState({
      isModalOpen: true,
    });
    setWhatYouNeedToKnow(fulfillmentType);
  };

  onClickCloseModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  render() {
    const { isModalOpen } = this.state;
    const {
      btnContent,
      groupIndex,
      fulfillmentType,
      btnAlignTop,
      modalHeading,
      children,
      height,
      width,
    } = this.props;
    let { dataId } = this.props;

    if (!dataId) {
      dataId = `whatYouNeedToKnow-${groupIndex}-${fulfillmentType}`;
    }
    return (
      <React.Fragment>
        <ButtonLink
          onClick={this.onClickOpenModal}
          content={btnContent}
          dataId={dataId}
          alignTop={btnAlignTop}
        />
        <Modal
          isOpen={isModalOpen}
          modalHeading={modalHeading}
          closeModal={this.onClickCloseModal}
          closeOnOverlayClick
          height={height || 'auto'}
          width={width || 'auto'}
          isScrollable
        >
          {children}
        </Modal>
      </React.Fragment>
    );
  }
}

InfoModal.defaultProps = {
  dataId: '',
};

export default InfoModal;
